import { css, SerializedStyles, Theme } from '@emotion/react'
import { COLORS } from 'parameters/index'
import { ColorProperties } from '../../../styles'
import { BrandColors } from '../../../styles/definitions/colors/brandColors'

type PresetOptions = 'magnoliaGradient' | 'primaryPurple' | 'lightPurple' | 'grey'
type PresetType = { value: PresetOptions }
type ColorType = { value: string }
type GradientType = { start: string } & { end: string } & { angle?: number }

export type Background =
	| ({ type: 'preset' } & PresetType)
	| ({ type: 'color' } & ColorType)
	| ({ type: 'gradient' } & GradientType)

// TODO: Update to new Theme Definition (and move to styles)
export const Backgrounds: Record<PresetOptions, SerializedStyles> = {
	grey: css`
		background-color: #eee;
	`,
	lightPurple: css`
		background-color: ${COLORS.LIGHT_PURPLE};
	`,
	primaryPurple: css`
		background-color: ${COLORS.KSU_PURPLE};
	`,
	magnoliaGradient: css`
		${BrandColors.Purple.toMod()};
		color: ${ColorProperties.On};
		background-color: ${COLORS.MAGNOLIA};
		background: linear-gradient(90deg, #3b0d68 0%, #592b86 100%);
	`
}

// TODO: Update to new Theme Definition
const getBackgroundStyles = (background: Background): SerializedStyles => {
	switch (background.type) {
		case 'preset':
			return Backgrounds[background.value]

		case 'color':
			return css`
				background-color: ${background.value};
			`
		case 'gradient':
			const angle = background.angle || 90
			return css`
				// background-color: ${background.start};
				background: linear-gradient(${angle.toFixed(0)}deg, ${background.start} 0%, ${background.end} 100%);
			`
	}
}

export const RibbonBackgroundTheme = (props: { theme: Theme }): SerializedStyles =>
	getBackgroundStyles(props.theme.ribbon.background)

export const CardBackgroundTheme = (props: { theme: Theme }): SerializedStyles =>
	getBackgroundStyles(props.theme.card.background)

export const CardBorderTheme = (props: { theme: Theme }): SerializedStyles => css({ border: props.theme.card.border })

export const IconBackgroundTheme = (props: { theme: Theme }): SerializedStyles =>
	css({ background: props.theme.icon.backgroundColor })

export const IconColorTheme = (props: { theme: Theme }): SerializedStyles =>
	css({ color: props.theme.icon.primaryFill })
